export default __webpack_public_path__ + "static/media/ba-4.d0fd4eeb.jpeg";